
import { reactive, toRefs, useContext } from '@nuxtjs/composition-api'
import { ACTION_STATUS } from '~/constants/ActionStatus';

export const useEmailValidation = () => {
  // @ts-ignore-next-line
  const { $hubble } = useContext()

  const state = reactive({
    valid: false,
    errors: [],
    messages: [],
    loading: false
  })

  /**
  * @param {string} value
  */
  const validate = async (email, cartID) => {
    state.errors = []
    state.messages = []

    state.loading = true
    state.messages = ['Vent venligst, mens vi kontrollerer din email']

    try {
      const { data } = await $hubble.validation.validateEmailAndAddToCart(cartID, email)

      if (data?.actionStatus === ACTION_STATUS.OK) {
        state.valid = true
        state.errors = []
      } else {
        state.valid = false
        state.errors = [data.actionErrors[0].notificationMessage]
      }
      state.loading = false
      state.messages = []

      return data?.responseObject
    } catch (error) {
      state.valid = false
      state.loading = false
      state.errors = ['Ups! Der skete en fejl. Prøv igen senere']
      state.messages = []

      return false
    }
  }

  /**
   * @param {string} value
   */
  const validateEmailForSignUp = async (bundleId, email) => {
    state.errors = []
    state.messages = []

    state.loading = true
    state.messages = ['Vent venligst, mens vi kontrollerer din email']

    try {
      const { data } = await $hubble.validation.validateEmailForSignUp(bundleId, email)
      return data
    } catch (error) {
      state.valid = false
      state.loading = false
      state.errors = ['Ups! Der skete en fejl. Prøv igen senere']
      state.messages = []
      return false
    }
  }

  return {
    ...toRefs(state),
    validate,
    validateEmailForSignUp
  }
}
